module.exports = __webpack_public_path__ + "static/media/mi6.ecf8f813.jpg";